import { LocalStorageService } from './../../../../core/services/local-storage.service';

import { environment } from './../../../../../environment/environment';
import { serverError } from './../../../../core/models/messages';
import { SortDataService } from './../../../../core/services/sortdata';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component, ElementRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import { Subject, takeUntil } from 'rxjs';
import { headerColumns1, translations } from '../../../../core/models/call-offer';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';


@Component({
  selector: 'app-call-offer-list',
  templateUrl: './call-offer-list.component.html',
  styleUrls: ['./call-offer-list.component.css'],
})
export class CallOfferListComponent {
  connectedUser = this.localStorageService.getData('userConnected');
  headerColumns: { checked: boolean; name: string; code: string }[] =
  headerColumns1;
  loadSpinner: boolean = false;
  idappel: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  sortAttr = '';
  currentUser: any;
  company_id: any;
  companyRoleId: any;
  pagination : boolean =false;

  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  mobilities: any[] = [];
  searchForm: FormGroup = this.createSearchForm();
  applyForm: FormGroup = this.createForm();
  currentSortColumn: string = 'name'; // Initial column to sort by
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList: any = [];
  dataHeader: any = [];
  listNames: string[] = [];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  selectedUserId!: string;
  nameEsn = this.localStorageService.getData('clientConnectedName');
  idclientConnected: any;
  isCollapsed = true;
  iduser: any;
  listconsultant: { first_name: string; id: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();

  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];

  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
    
  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  skillsList: { name_FR: string }[] = [];
  typeintervenant: any;
  isLoadSpinner: boolean = true;

  startSearching:boolean = false;
  
  constructor(
    private formBuilder: FormBuilder,
    private appeloffreservice: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private salarieservice: SalarieService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private router: Router,

  ) {}
  ngOnInit() {
    this.idclientConnected =
    this.localStorageService.getData('clientConnected');
    this.typeintervenant = this.localStorageService.getData('typeintervenant');

    this.countries = Country.getAllCountries();
    this.getListappeloffre();
    this.getListSkills();
    this.getlistconsultant();
    this.getListElementHeader();
    this.getcurrentUser();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  getClass(item: string): string {
    if (item === 'Nom entreprise') {
      return 'th-fixed';
    } else if (item === 'Poste') {
      return 'th-fixed2';
    }
    return '';
  }
  navigate(user : any,name : string) {
    this.router.navigate([
      '/chat/chat-list',
      { user: user,name:name},
    ]);
}
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appeloffreservice
        .getHeaderElements(11)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.appeloffreservice
        .listPageActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }

  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
  }
  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }
  isEsnNotSubscribed(): boolean {
    
    return !this.companyRoleId.includes('8');
  }
  isEsnSubscribed(): boolean {
    return this.companyRoleId.includes('7') ;
  }

  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.appeloffreservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.appeloffreservice
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }
  
  sortData(item: string) {
    for (const iterator of headerColumns1) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;

    if (this.searchForm.dirty)
      this.listappeloffre = this.sortDataService.sortArray(
        this.listappeloffre,
        item,
        this.currentSortDirection
      );
    else this.getListappeloffre();
  }

  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchappeloffre();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListappeloffre();
      }
    }
  }

  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          } else {
          }
        }
      }
    });


    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }

  reset() {
    this.stateList=[];
    this.currentPage = 1;
    this.endIndex = 5;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchappeloffre();
  }
  getListappeloffre() {
    let dataPyload =
      this.sortAttr == ''
        ? { per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.spinner.show();
    this.appeloffreservice.getListappeloffre(dataPyload).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.listappeloffre = response.data.data;
          this.totalItems = response.data.total;
          this.spinner.hide();

        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      // esn_id: ['', data?.esn_id],
      name: ['', data?.name],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
      ID_jobRequest: ['', data?.ID_jobRequest],
      experience_range: ['', data?.experience_range],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      client_final_name: ['', data?.client_final_name],
      contract_type: [[], data?.contract_type],
      post_type: [[], data?.post_type],
      years_of_experience: ['', data?.years_of_experience],
      city: [[], data?.city],
      country: [[], data?.country],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
    });
  }
  /* search */
  searchappeloffre(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    valueForm.desired_salary_range = this.convertKToNumber(
      valueForm.desired_salary_range.toString()
    );
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    let data = {
      name: valueForm.name,
      ID_jobRequest: valueForm.ID_jobRequest,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      client_final_name: valueForm.client_final_name,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      city: valueForm.city,
      country: valueForm.country,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      state: valueForm.state,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: this.searchForm.value.desired_salary_range,
      search: this.transformSearch(valueForm?.search),
      per_page: this.itemsPerPage,
      page: pageNumber,
    };
    

    this.spinner.show();
    this.appeloffreservice.searchappeloffre(data).subscribe({
      next: (resSearch) => {
        if(this.startSearching == true) {
          this.currentPage = 1;
          this.startSearching = false;
        }  
          this.listappeloffre = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: (error) => {
        this.toastrService.error(serverError);
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }
  archiverappeloffre(id: any) {
    Swal.fire({
      title: 'Vous êtes sûr d’archiver l’offre sélectionnée ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, archiver !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.appeloffreservice
          .archiverappeloffre(id, this.idclientConnected)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’appel d’offre a été archivé avec succès.'
                );
                this.searchappeloffre();
               
              }
            },
            error: (error: any) => {
            },
          });
      }
    });
  }
  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;


      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    } else {
      // La case est décochée, vous pouvez ajouter un code supplémentaire si nécessaire
    }
  }

  //////////////////postuler offre////////////////////////////////

  open(appel: any) {
    this.idappel = appel.id;
  }
  getlistconsultant() {
    this.appeloffreservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
      },
      error: (error) => {
      },
    });
  }
  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }
  pastDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = control.value;
      if (date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ignorer les heures pour comparer uniquement les dates
        const inputDate = new Date(date);

        if (inputDate < today) {
          return { pastDate: true };
        }
      }
      return null;
    };
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [
        data ? data.availibility_date : '',
        [this.pastDateValidator()],
      ],
      user_id: [data ? data.user_id : null, [Validators.required]],
    });
  }
  applyJob() {
    let data = {
      company_id: this.idclientConnected,
      user_id: this.selectedUserId,
      job_request_id: this.idappel,
    };
    this.appeloffreservice
      .applyJob({ ...data, ...this.applyForm.value })
      .subscribe({
        next: (res: any) => {
          this.applyForm.reset();
          this.toastrService.success(
            'votre candidature a été envoyé avec succès.'
          );
        },
        error: (error) => {
          this.applyForm.reset();
          if (error.error.message === 'candidature already exist.') {
            this.toastrService.error(
              'Vous avez déjà postulé à cet appel offre'
            );
          }
          if (error.error.message === 'the job offer has been deactivated.') {
            this.toastrService.error(
              "La postulation n'est pas autorisée car l'appel d'offres est désactivé."
            );
          }
        },
      });
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
}
